export default "__VITE_ASSET__BAb$OAkv__"